import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-bottom">
      © All Rights Reserved | AavryaaFabHub |  Kavinraj 
    </div>
  );
};

export default Footer;
